import css from './solartracker.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { BannerModule, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { getImageLocal } from '@/utils/locals';
import NextImage from '@/components/NextImage';
import OtherList from '@/components/ProductCommon/OtherList';

export default function Solartracker() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { t } = useLang('solartracker');
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const webpUrl = '/media/solartracker/h5/';
    const banner_items = [
        {
            bgImgs: ['solartracker_banner_h5.webp', 'solartracker_banner_h5.jpg'],
            title: t('solar_tracker.title'),
            des: t('solar_tracker.subtitle'),
        },
    ];
    const textWithImgItem1 = {
        title: t('solar_tracker.third_title'),
        synopsis: t('solar_tracker.third_subtitle'),
        desc: `${t('solar_tracker.third_des_gray')}<span style="color:#000"> ${t('solar_tracker.third_des_black')}</span>`,
        img_url: ['solartracker1_h5.webp', 'solartracker1_h5.jpg'],
    };
    const textWithImgItem2 = {
        title: t('solar_tracker.four_title'),
        synopsis: t('solar_tracker.four_subtitle'),
        desc: t('solar_tracker.four_des'),
        phrase: t('solar_tracker.four_text'),
        img_url: ['solartracker2_h5.webp', 'solartracker2_h5.jpg'],
    };
    const textWithImgItem3 = {
        synopsis: `${t('solar_tracker.five_title')}</br>${t('solar_tracker.five_subtitle')}`,
        alt: t('solar_tracker.five_title') + t('solar_tracker.five_subtitle'),
        desc: t('solar_tracker.five_des'),
        img_url: ['solartracker3_h5.webp', 'solartracker3_h5.jpg'],
    };
    const textWithImgItem4 = {
        synopsis: t('solar_tracker.six_title'),
        alt: t('solar_tracker.six_title'),
        desc: t('solar_tracker.six_des'),
        img_url: [`solartracker4_h5_${imgLocal}.webp`, `solartracker4_h5_${imgLocal}.jpg`],
    };
    const otherProduct = getDetaileMoreProducts(
        gloproductlist,
        ['product_sp_400w_solar_panel', 'product_sp_160w_solar_panel'],
        '',
        '',
        locale === 'us' ? 'https://us.ecoflow.com/collections/solar-generators' : `https://${locale}.ecoflow.com/collections/solar-panels`,
    );
    return (
        <div className={`${css.solartracker}`}>
            <div style={{ width: '100%' }} className="bannerModule1">
                <BannerModule
                    config={{
                        position: 'top',
                        titleFontSize: 0.4,
                        theme: 'black',
                        webpUrl,
                    }}
                    data={banner_items}
                />
            </div>
            <div className="banner-content">
                <div className="section section1">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec1_tit')}</h3>
                    <p className="subtit">{t('solar_tracker.ytdd_sec1_subtit1')}</p>
                    <p className="subtit">{t(locale === 'de' ? 'solar_tracker.ytdd_sec1_subtit2_de_h5' : 'solar_tracker.ytdd_sec1_subtit2')}</p>
                    <div className="bg-img">
                        <NextImage
                            className="fullImgs"
                            layout="fill"
                            alt={t('Solar Tracker')}
                            webpSrc={require('@publicLocal/solartracker/h5/section1_h5@3x.webp')}
                            src={require('@publicLocal/solartracker/h5/section1_h5@3x.png')}
                        />
                    </div>
                </div>
                <div className="section section2">
                    <h3 className="tit">
                        {t('solar_tracker.ytdd_sec2_tit')}
                        <span className="union">{t('solar_tracker.ytdd_sec2_union')}</span>
                    </h3>
                    <p className="subtit">{t('solar_tracker.ytdd_sec2_subtit1')}</p>
                    <p className="subtit">{t('solar_tracker.ytdd_sec2_subtit2')}</p>
                    <div className="bg-img">
                        <NextImage
                            className="fullImgs"
                            layout="fill"
                            alt={t('Solar Tracker')}
                            webpSrc={require('@publicLocal/solartracker/h5/section2_h5@3x.webp')}
                            src={require('@publicLocal/solartracker/h5/section2_h5@3x.png')}
                        />
                    </div>
                </div>
                <div className="section section3">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec3_tit')}</h3>
                    <p className="subtit">{t('solar_tracker.ytdd_sec3_subtit1')}</p>
                    <p className="subtit">{t('solar_tracker.ytdd_sec3_subtit2')}</p>
                    <div className="bg-img">
                        <NextImage
                            className="fullImgs"
                            layout="fill"
                            alt={t('Solar Tracker')}
                            webpSrc={require('@publicLocal/solartracker/h5/section3_h5@3x.webp')}
                            src={require('@publicLocal/solartracker/h5/section3_h5@3x.png')}
                        />
                    </div>
                </div>
                <div className="section section5">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec5_tit')}</h3>
                    <div className="bg-img">
                        <NextImage
                            className="fullImgs"
                            layout="fill"
                            alt={t('Solar Tracker')}
                            webpSrc={require('@publicLocal/solartracker/h5/section5_h5@3x.webp')}
                            src={require('@publicLocal/solartracker/h5/section5_h5@3x.png')}
                        />
                    </div>
                </div>
                <div className="section section4">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec4_tit')}</h3>
                    <div className="bg-img">
                        <NextImage
                            className="fullImgs"
                            layout="fill"
                            alt={t('Solar Tracker')}
                            webpSrc={require('@publicLocal/solartracker/h5/section4_h5@3x.webp')}
                            src={require('@publicLocal/solartracker/h5/section4_h5@3x.png')}
                        />
                    </div>
                </div>
                <div className="section section7">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec7_tit')}</h3>
                    <p className="subtit">{t('solar_tracker.ytdd_sec7_subtit1')}</p>
                    <div className="bg-img">
                        <NextImage
                            className="fullImgs"
                            layout="fill"
                            alt={t('Solar Tracker')}
                            webpSrc={require('@publicLocal/solartracker/h5/section7_h5@3x.webp')}
                            src={require('@publicLocal/solartracker/h5/section7_h5@3x.png')}
                        />
                    </div>
                </div>
                <div className="section section6">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec6_tit')}</h3>
                    <p className="subtit">{t('solar_tracker.ytdd_sec6_subtit1')}</p>
                    <div className="bg-img">
                        <NextImage
                            className="fullImgs"
                            layout="fill"
                            alt={t('Solar Tracker')}
                            webpSrc={require('@publicLocal/solartracker/h5/section6_h5@3x.webp')}
                            src={require('@publicLocal/solartracker/h5/section6_h5@3x.png')}
                        />
                    </div>
                </div>
            </div>
            <TextWithImage data={textWithImgItem1} config={{ position: 'top', descColor: '#9b9b9b', text: 'center', webpUrl }} />
            <LineSpace height={0.8} background="#fff" />
            <TextWithImage
                config={{
                    position: 'top',
                    titleColor: '#03060b',
                    synopsisColor: '#03060b',
                    descColor: '#222',
                    phraseColor: '#919191',
                    text: 'center',
                    webpUrl,
                }}
                data={textWithImgItem2}
            />
            <TextWithImage
                config={{
                    position: 'top',
                    descColor: '#222',
                    fullScreen: false,
                    webpUrl,
                }}
                data={textWithImgItem3}
            />
            <LineSpace height={0.8} background="#fff" />
            <TextWithImage
                config={{
                    position: 'top',
                    gradient: true,
                    gradientColor: 'linear-gradient(#ff962b, #f08086)',
                    descColor: '#222',
                    webpUrl,
                }}
                data={textWithImgItem4}
            />
            <LineSpace height={1.2} background="#fff" />
            <OtherList data={otherProduct} />
        </div>
    );
}
